import { LucideIcon, MoreHorizontal, Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export interface InventoryRowAction {
  label: string;
  icon: LucideIcon;
  onClick: () => void;
  destructive?: boolean;
}

interface InventoryRowActionsMenuProps {
  actions: InventoryRowAction[];
}

/** Row actions dropdown — same pattern as Products list. */
export function InventoryRowActionsMenu({ actions }: InventoryRowActionsMenuProps) {
  if (actions.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" aria-label="Row actions">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {actions.map((action) => (
          <DropdownMenuItem
            key={action.label}
            onClick={action.onClick}
            className={action.destructive ? 'text-red-600' : undefined}
          >
            <action.icon className="mr-2 h-4 w-4" />
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function editDeleteRowActions(
  onEdit: () => void,
  onDelete: () => void
): InventoryRowAction[] {
  return [
    { label: 'Edit', icon: Pencil, onClick: onEdit },
    { label: 'Delete', icon: Trash2, onClick: onDelete, destructive: true },
  ];
}
